import { MenuItem } from './menu.model';

/*
╔════════════════════════════════════════════════════════════════════════════════════════╗
║                                                                                        |
║  ██╗███╗   ███╗██████╗  ██████╗ ██████╗ ████████╗ █████╗ ███╗   ██╗████████╗           ║
║  ██║████╗ ████║██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝██╔══██╗████╗  ██║╚══██╔══╝           ║
║  ██║██╔████╔██║██████╔╝██║   ██║██████╔╝   ██║   ███████║██╔██╗ ██║   ██║              ║
║  ██║██║╚██╔╝██║██╔═══╝ ██║   ██║██╔══██╗   ██║   ██╔══██║██║╚██╗██║   ██║              ║
║  ██║██║ ╚═╝ ██║██║     ╚██████╔╝██║  ██║   ██║   ██║  ██║██║ ╚████║   ██║              ║
║  ╚═╝╚═╝     ╚═╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝╚═╝  ╚═══╝   ╚═╝              ║
║                                                                                        ║
║  ██████╗  ██████╗     ███╗   ██╗ ██████╗ ████████╗                                     ║
║  ██╔══██╗██╔═══██╗    ████╗  ██║██╔═══██╗╚══██╔══╝                                     ║
║  ██║  ██║██║   ██║    ██╔██╗ ██║██║   ██║   ██║                                        ║
║  ██║  ██║██║   ██║    ██║╚██╗██║██║   ██║   ██║                                        ║
║  ██████╔╝╚██████╔╝    ██║ ╚████║╚██████╔╝   ██║                                        ║
║  ╚═════╝  ╚═════╝     ╚═╝  ╚═══╝ ╚═════╝    ╚═╝                                        ║
║                                                                                        ║
║   ██████╗██╗  ██╗ █████╗ ███╗   ██╗ ██████╗ ███████╗                                   ║
║  ██╔════╝██║  ██║██╔══██╗████╗  ██║██╔════╝ ██╔════╝                                   ║
║  ██║     ███████║███████║██╔██╗ ██║██║  ███╗█████╗                                     ║
║  ██║     ██╔══██║██╔══██║██║╚██╗██║██║   ██║██╔══╝                                     ║
║  ╚██████╗██║  ██║██║  ██║██║ ╚████║╚██████╔╝███████╗                                   ║
║   ╚═════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚══════╝                                   ║
║                                                                                        ║
║  ███╗   ███╗███████╗███╗   ██╗██╗   ██╗    ██╗██████╗ ███████╗                         ║
║  ████╗ ████║██╔════╝████╗  ██║██║   ██║    ██║██╔══██╗██╔════╝                         ║
║  ██╔████╔██║█████╗  ██╔██╗ ██║██║   ██║    ██║██║  ██║███████╗                         ║
║  ██║╚██╔╝██║██╔══╝  ██║╚██╗██║██║   ██║    ██║██║  ██║╚════██║                         ║
║  ██║ ╚═╝ ██║███████╗██║ ╚████║╚██████╔╝    ██║██████╔╝███████║                         ║
║  ╚═╝     ╚═╝╚══════╝╚═╝  ╚═══╝ ╚═════╝     ╚═╝╚═════╝ ╚══════╝                         ║
║                                                                                        ║
║  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  IMPORTANT  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️                             ║
║                                                                                        ║
║  🚨 DO NOT CHANGE MENU IDs 🚨                                                          ║
║                                                                                        ║
║  IDs are used by the permissions and roles system.                                     ║
║  Changing these values can break authorization functionality                           ║
║  and cause critical errors in the application.                                         ║
║                                                                                        ║
║  If you need to add new elements:                                                      ║
║  ✅ Use the next available ID in sequence                                              ║
║  ✅ Add its route with data: { viewId: <ID> }                                          ║
║  ✅ Assign it to users in /#/permissions                                               ║
║                                                                                        ║
║  If you need to modify existing elements:                                              ║
║  ❌ NEVER change the ID                                                                ║
║  ✅ Only modify label, icon, link or subItems as needed                                ║
║                                                                                        ║
║  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️  ⚠️               ║
║                                                                                       ║
╚════════════════════════════════════════════════════════════════════════════════════════╝
*/

export const MENU: MenuItem[] = [
	{
		id: 0,
		label: 'MENUITEMS.MENU.TEXT',
		isTitle: true,
	},
	{
		id: 1,
		label: 'Command Center',
		icon: 'ri-home-5-fill',
		link: '/command-center',
	},
	{
		id: 2,
		label: 'Production Board',
		link: '/production-board',
		icon: 'ri-dashboard-fill',
	},
	{
		id: 3,
		label: 'Caller Tracking',
		icon: 'ri-customer-service-2-fill',
		link: '/caller-tracking',
	},
	{
		id: 4,
		label: 'Campaigns',
		icon: 'ri-briefcase-fill',
		link: '/campaigns',
	},
	{
		id: 5,
		label: 'Users',
		icon: 'ri-account-circle-line',
		subItems: [
			// {
			// 	id: 4,
			// 	label: 'Employee Users',
			// 	link: '/employee-users',
			// 	parentId: 3,
			// },
			{
				id: 6,
				label: 'Users',
				link: '/users',
				parentId: 5,
			},
			{
				id: 7,
				label: 'Permissions',
				link: '/permissions',
				parentId: 5,
			},
		],
	},
	{
		id: 8,
		label: 'Quality Control',
		icon: 'ri-line-chart-line',
		link: '/quality-control',
		subItems: [
			{
				id: 9,
				label: 'Quality Control',
				link: '/quality-control',
				parentId: 8,
			},
			{
				id: 25,
				label: 'New QC',
				link: '/new-qc',
				parentId: 8,
			},
			// {
			// 	id: 9,
			// 	label: 'Forecast',
			// 	link: '/forecast/week',
			// 	parentId: 6,
			// },
			// {
			// 	id: 11,
			// 	label: 'Historical Forecast',
			// 	link: '/forecast/history',
			// 	parentId: 6,
			// },
			{
				id: 10,
				label: 'Callers Report',
				link: '/callers-reports',
				parentId: 8,
			},
			{
				id: 11,
				label: 'Dispos Report',
				link: '/dispo-reports',
				parentId: 8,
			},
			{
				id: 23,
				label: 'Campaign Effort',
				icon: 'ri-bar-chart-line',
				link: '/campaign-effort',
			},
			{
				id: 24,
				label: 'Vera AI',
				icon: 'ri-robot-2-fill',
				link: '/vera-ai',
			},
		],
	},
	{
		id: 14,
		label: 'Billing',
		link: '/billing-report',
		icon: 'ri-dashboard-fill',
	},
	// {
	// 	id: 12,
	// 	label: 'Billing',
	// 	link: '/billing-authorize',
	// 	icon: 'ri-dashboard-fill',
	// 	subItems: [
	// 		{
	// 			id: 13,
	// 			label: 'Billing',
	// 			link: '/billing-authorize',
	// 			parentId: 12,
	// 		},
	// 		{
	// 			id: 14,
	// 			label: 'Report',
	// 			link: '/billing-report',
	// 			parentId: 12,
	// 		},
	// 	],
	// },

	// {
	// 	id: 18,
	// 	label: 'Billing',
	// 	icon: 'ri-bill-line',
	// 	subItems: [
	// 		{
	// 			id: 19,
	// 			label: 'NMI',
	// 			link: '/billing',
	// 			parentId: 18,
	// 		},
	// 		{
	// 			id: 20,
	// 			label: 'Authorize',
	// 			link: '/billing-authorize',
	// 			parentId: 18,
	// 		},
	// 		{
	// 			id: 21,
	// 			label: 'Authorize Chase',
	// 			link: '/billing-authorize-chase',
	// 			parentId: 18,
	// 		},
	// 		{
	// 			id: 22,
	// 			label: 'Chargebacks',
	// 			link: '/chargebacks',
	// 			parentId: 18,
	// 		},
	// 		{
	// 			id: 27,
	// 			label: 'Report',
	// 			link: '/billing-report',
	// 			parentId: 18,
	// 		},
	// 	],
	// },
	{
		id: 15,
		label: 'Tickets',
		icon: 'ri-chat-1-fill',
		subItems: [
			{
				id: 16,
				label: 'Black Out Days',
				link: '/black-out-days',
				parentId: 15,
			},
			{
				id: 17,
				label: 'Reschedule Leads',
				link: '/reschedule-leads',
				parentId: 15,
			},
			{
				id: 18,
				label: 'Replacement Leads',
				link: '/replacement-leads',
				parentId: 15,
			},
			{
				id: 19,
				label: 'Support Tickets',
				link: '/support-tickets',
				parentId: 15,
			},
		],
	},

	{
		id: 20,
		label: 'List Upload',
		icon: 'ri-git-repository-commits-fill',
		link: '/list-upload',
	},
	{
		id: 21,
		label: 'Prospects',
		icon: 'ri-group-fill',
		link: '/prospects',
	},

	{
		id: 22,
		label: 'Archives',
		icon: 'ri-folder-open-line',
		link: '/archive',
	},

	{
		id: 26,
		label: 'AI Agents (Coming soon)',
		icon: 'ri-robot-line',
		link: '/ai-agents',
		disabled: false,
	},

	// {
	// 	id: 23,
	// 	label: 'Notifications',
	// 	icon: 'ri-notification-3-line',
	// 	link: '/notifications',
	// }
];
